// React
import React from 'react'
// External Lib
import { useNavigate } from 'react-router-dom'
import { get } from 'lodash'
// Material UI
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
// Interfaces
import { Props } from './props'
// Hooks
import hooks from './hooks'
// Styles
import useStyles from './style'
// Constants
import Paths from '../../../../constants/Paths'
import EventActions from '../../../../redux/actions/event-actions/event.actions'
import appStore from '../../../../redux/stores/app.store'

const CategoryDetail: React.FC<Props> = () => {
  const componentClasses = useStyles()
  const category = hooks.useSelectedCategory()
  const nameCategory = get(category, 'name', '')
  const categoryId = get(category, 'id', '')
  const subCategories = get(category, 'sections') || []
  const partnerId = appStore.getPartnerId()
  const navigate = useNavigate()
  return (
    <div className={componentClasses.root}>
      <div className={componentClasses.categoryContainer}>
        <div className={componentClasses.title}>{nameCategory}</div>
        <div className={componentClasses.subCategoriesContainer}>
          {subCategories.map((subcategory, index: number) => {
            return (
              <div
                key={`subcategory-${index}`}
                className={componentClasses.subCategory}
              >
                <div className={componentClasses.categoryTitle}>
                  {subcategory.name}
                </div>
                {subcategory.articles.map((article, index: number) => {
                  return (
                    <div
                      key={`article-${index}`}
                      className={componentClasses.article}
                      onClick={() => {
                        EventActions.onSuccessfulArticle(article.id)
                        EventActions.onSuccessSelectedArticle(
                          partnerId,
                          nameCategory,
                          subcategory.name,
                          article.name,
                        )
                        navigate(
                          Paths.getHelpcenterCategoryIdWithArticleQueryParamsPath(
                            categoryId,
                            article.id,
                          ),
                        )
                      }}
                    >
                      <KeyboardArrowRightIcon
                        className={componentClasses.arrow}
                      />
                      {article.name}
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
export default CategoryDetail
